import { useMemo } from 'react';

import useColor from '@/hooks/domain/useColor';
import { cn } from '@/lib/cn';
import useCustomerStore from '@/stores/CustomerStore';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { charToNumber } from '@/utils/util';

import Avatar from './Avatar';
import { AvartarType } from './avatarConst';

type Props = {
  text?: string;
  type?: AvartarType;
  size?: number;
  withText?: boolean;
  withAvatar?: boolean;
  className?: string;
  textClassName?: string;
  avatarFontSize?: string;
};

const ProfileAvatar = (props: Props = { withAvatar: true }) => {
  const color = useColor();
  const { currWorkspaceMembers } = useWorkspaceStore((state) => ({
    currWorkspaceMembers: state.currWorkspaceMembers,
  }));
  const { customerMap } = useCustomerStore((state) => ({
    customerMap: state.customerMap,
  }));

  const name = useMemo(() => {
    if (!props.text && props.type === AvartarType.TEXT) return 's';
    if (!props.text) return '?';
    if (!props.type || props.type === 1) {
      const user = currWorkspaceMembers.find(
        (user) => user.user_id === props.text,
      );
      return user?.first_name ? user?.first_name : '?';
    } else if (props.type === 2) {
      const customer = customerMap[props.text];
      return customer?.name ? customer.name : '?';
    } else {
      return props.text;
    }
  }, [currWorkspaceMembers, customerMap, props]);

  const avartar = useMemo(() => {
    return name[0].toUpperCase();
  }, [name]);

  const avartarColor = useMemo(() => {
    if (!props.type || props.type === 1) {
      const user = currWorkspaceMembers.find(
        (user) => user.user_id === props.text,
      );
      const colorIndex = user?.color || 1;
      return color.profile[colorIndex];
    } else {
      return color.profile[charToNumber(avartar)];
    }
  }, [currWorkspaceMembers, props.text, avartar, color.profile, props.type]);

  return (
    <div className={cn('flex items-center gap-1.5', props.className)}>
      {props.withAvatar !== false && (
        <Avatar
          character={avartar}
          size={props.size || 18}
          color={avartarColor}
          fontSize={props.avatarFontSize || '12px'}
        />
      )}
      {props.withText && (
        <span className={cn('text-xs', props.textClassName)}>{name}</span>
      )}
    </div>
  );
};

export default ProfileAvatar;
